import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ApexOptions} from 'ng-apexcharts';
import {WidgetChartControllerComponent} from '../../../Controller/widget-chart-controller-component';
import {LineChartDto} from '../../../../Models/Chart/line-chart.interface';

@Component({
  selector: 'app-widget-line-chart',
  templateUrl: './widget-line-chart.component.html',
  styleUrls: ['./widget-line-chart.component.scss'],
  standalone: false
})
export class WidgetLineChartComponent extends WidgetChartControllerComponent implements OnChanges {

  @Input() data!: LineChartDto | null;

  chartOptions!: ApexOptions;


  /**
   * Se ejecuta si hay cambios en la variable 'data'
   *
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['data']) {
      this.initChart();
    }
  }


  /**
   * Inicializar gráfica
   *
   */
  initChart() {
    this.chartOptions = {
      series: this.data?.series || [],
      chart: {
        type: 'line',
        height: 375,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        width: 2.5,
        curve: 'smooth'
      },
      legend: {
        itemMargin: {
          horizontal: 7,
          vertical: 10
        }
      },
      xaxis: {
        categories: this.data?.categories || [],
        tickAmount: 15,
        labels: {
          trim: true,
          maxHeight: 120,
          hideOverlappingLabels: false,
          rotateAlways: true,
          style: {
            fontSize: '11px'
          }
        }
      },
      yaxis: {
        labels: {
          formatter: ((value: number): string => this.setFormat(value)),
        }
      },
      tooltip: {
        y: {
          formatter: (value: number, {seriesIndex}: any) => {
            const unit: string = this.data?.series?.[seriesIndex]?.['unit'] || '€';
            return this.setFormat(value, unit);
          }
        }
      }
    };
  }

}
